import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { MyErrorStateMatcher, ValidatorConfig } from '../../../../../../common/field-validation/my-error-state-matcher';
import { UiValidator } from '../../../../../../common/field-validation/ui-validator.dto';

@Component({
  selector: 'app-form-field-number',
  templateUrl: './number-form-field.component.html',
  styleUrls: ['./number-form-field.component.scss'],
  standalone: false,
})
export class NumberFormFieldComponent extends DataTypeComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  @Output() valueClick: EventEmitter<void> = new EventEmitter<void>();

  matcher = new MyErrorStateMatcher();

  formattedNumber: string;

  private entity: number;

  constructor(private changeDetector: ChangeDetectorRef) {
    super();
  }

  condition(v: UiValidator) {
    const formControl = this.getFormControl();
    return this.getValidatorConfig(v).condition(formControl);
  }

  message(v: UiValidator) {
    return this.getValidatorConfig(v).message(v);
  }

  private getValidatorConfig(v: UiValidator): ValidatorConfig {
    return MyErrorStateMatcher.messageMap[v.type];
  }

  private getFormControl(): AbstractControl {
    return this.formGroup.get(this.fieldConfig.name);
  }

  ngOnInit(): void {
    this.initialiseValue();
  }

  private initialiseValue() {
    if (this.fieldConfig.jsValue) {
      const { entity } = this;
      this.data = eval(this.fieldConfig.jsValue);
    }
    if (!this.editMode && this.fieldConfig.type === 'number') {
      if (this.fieldConfig.localeFormatted) {
        if (this.data !== undefined && typeof this.data === 'number') {
          const num: number = this.data;
          this.formattedNumber = num.toLocaleString();
        } else {
          this.formattedNumber = this.data;
        }
      } else {
        this.formattedNumber = this.data;
      }
    }
    this.initialise();
    this.changeDetector.detectChanges();
    if (this.fieldConfig.jsRecalculate) {
      setTimeout(() => this.initialiseValue(), 30000);
    }
  }

  getType() {
    return this.fieldConfig.type === 'number' ? 'number' : 'text';
  }

  setRowData(entity: any) {
    this.entity = entity;
  }
}
